import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Controller, useForm } from 'react-hook-form';
import { Tab, Row, Nav, Col, Form, Button, Badge, Spinner } from 'react-bootstrap';
import { paramCase } from 'change-case';
import { Link } from 'react-router-dom';
import { NumberToWords } from '@persian-tools/persian-tools';
import {
  getCourseItem,
  updateCourseItem,
  updateCourseFileData,
  setCourseItemNull,
  searchCourses,
} from '../store/action/CourseAction';
import { getOrganizationTeachers } from '../store/action/OrganizationAction';
import { getAllLanguage } from '../store/action/LanguageAction';
import { getAllLevelTypes } from '../store/action/LevelTypeAction';
import { detectBrowserName, permissionTypes } from '../../utils';
import { txtRT, txtRH, txtRHF, txtSA, txtPage } from '../../utils/texts';
import Head from '../../components/Head';
import FieldArray from '../../components/FieldArray';
import FileInput from '../../components/FileInput';
import DateTimePicker from '../../components/DateTimePicker';
import Toast from '../../components/Toast';
import Loader from '../../components/Loader';

import 'react-calendar-datetime-picker/dist/index.css';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { Select } from '../../components/Form';
import { formValues } from 'redux-form';
import DarsupSweetAlert, { titleGenerator } from '../../components/SweetAlert';

const UpdateCourse = ({ match, history }) => {
  const { tabLinks, btn, form } = txtPage.createCourse;

  // internal state
  const [sweet, setSweet] = useState({ show: false, redirect: false });
  const [btnStatus, setBtnStatus] = useState();

  const [hasLicence, setHasLicence] = useState(false);
  const [isFree, setIsFree] = useState(true);
  const [hasMultiPrice, setHasMultiPrice] = useState(false);

  // active key
  let [ak, setAK] = useState('marketing');

  let onShowTabContent = name => setAK(name);

  // state of redux
  let {
    courseItem: course,
    isLoading: is_loading,
    isLoadingVideoFile,
    error,
    showImagePreview,
    showVideoPreview,
  } = useSelector(state => state.course);

  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);
  const { organizationTeachers } = useSelector(state => state.OrganizationReducer);
  const instructors = organizationTeachers.results;

  let allLanguages = useSelector(state => state.language.all);
  let allLevelTypes = useSelector(state => state.levelType.all);

  const dispatch = useDispatch();

  // id is to split the edit and create
  const { id } = match.params;

  // react hook form
  const {
    register,
    handleSubmit,
    watch,
    errors,
    control,
    getValues,
    reset,
    formState,
    setError,
    clearError,
    setValue,
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      weeks_to_complete: null,
      min_effort: null,
    },
  });

  const startDate = watch('start');

  const titleValue = watch('title');
  const shortDescValue = watch('short-description');
  let videoFile = watch('video-file');
  const dirtyFields = Array.from(formState.dirtyFields);

  // apply style for the tab that has error
  const errorStyleForTabs = {
    tab1:
      errors['expected-learning-items'] || errors.prerequisites || errors['level-type'] || errors.language
        ? 'bg-danger text-white'
        : '',
    tab2:
      errors.title ||
      errors['short-description'] ||
      errors['full-description'] ||
      errors.start ||
      errors.end ||
      errors.min_effort ||
      errors.weeks_to_complete
        ? 'bg-danger text-white'
        : '',
    tab3: errors.price || errors.image || errors['video-url'] ? 'bg-danger text-white' : '',
  };

  // TEMPORARY REGISTRATION
  async function handleClickTempBtn() {
    let allValues = getValues();
    let { language, title, price, image, start, end, price_with_licence, min_effort, weeks_to_complete } = allValues;
    let levelType = allValues['level-type'];
    let shortDescription = allValues['short-description'];
    let fullDescription = allValues['full-description'];
    let instructors = allValues?.instructors?.map(teacher => (typeof teacher === 'number' ? teacher : teacher.id));

    let prerequisites_list = [];
    selectedRequisites.forEach(item => {
      prerequisites_list.push(item.key);
    });

    let expectedLearningItems = [];
    Object.keys(allValues).forEach(item => {
      if (item.includes('expected-learning-items') && Boolean(allValues[item]))
        expectedLearningItems.push(allValues[item]);
    });

    // ! prerequisites field should be added
    let compareOldAndNewArrayLength = {
      'expected-learning-items': course.expected_learning_items.length === expectedLearningItems.length,
    };

    let df = getDirtyFields(dirtyFields, compareOldAndNewArrayLength);

    let isAddLang = false;
    if (df.language) isAddLang = true;
    if (course.language === null) isAddLang = true;

    let isAddLevelType = false;
    if (df['level-type']) isAddLevelType = true;
    if (course.level_type === null) isAddLevelType = true;

    //price_policy
    var price_policy = '';
    if (isFree) {
      price_policy = 'free';
    } else {
      if (hasMultiPrice) {
        price_policy = 'paid_with_two_price';
      } else {
        price_policy = 'paid_with_one_price';
      }
    }

    let data = {
      ...(isAddLang && { language_code: language }),
      ...(isAddLevelType && { level_type_id: levelType }),
      ...(df.title && { title }),
      ...(df['short-description'] && { short_description: shortDescription }),
      ...(df['full-description'] && { full_description: fullDescription }),
      ...{ price },
      ...(df.start && { start }),
      ...(df.end && { end }),

      ...{
        price_policy: price_policy,
      },
      instructors,
      min_effort: min_effort ? min_effort : null,
      weeks_to_complete: weeks_to_complete ? weeks_to_complete : null,
      ...(!isFree &&
        hasMultiPrice && {
          price_with_certificate: price * 1,
        }),
      ...(!isFree &&
        hasMultiPrice && {
          price_without_certificate: price_with_licence * 1,
        }),
      ...{
        have_certificate: hasLicence && !isFree,
      },
    };
    let arrayData = {
      ...(df['expected-learning-items'] && {
        expected_learning_items_list: expectedLearningItems,
      }),
      prerequisites_list,
    };

    let uploadData = { ...data, ...arrayData };

    let roleName = paramCase(selectedRole.name);
    await dispatch(updateCourseItem(id, roleName, uploadData));
  }

  // PERMANENT REGISTRATION
  const onSubmit = async (formData, e) => {
    e.preventDefault();

    let publish = true;

    let { language, title, price, start, end, price_with_licence, min_effort, weeks_to_complete } = formData;

    let expectedLearningItems = formData['expected-learning-items'];
    let levelType = formData['level-type'];
    let shortDescription = formData['short-description'];
    let fullDescription = formData['full-description'];

    let prerequisites_list = [];
    prerequisites_list.map(item => {
      prerequisites_list.push(item.key);
    });

    if (!expectedLearningItems) {
      setError('expected-learning-items', 'notMatch', 'این فیلد الزامی است');
      return;
    }
    expectedLearningItems = expectedLearningItems.filter(item => Boolean(item.length));

    if (!expectedLearningItems.length) {
      setError('expected-learning-items', 'notMatch', 'این فیلد الزامی است');
      return;
    }

    let instructors = formData?.instructors?.map(teacher => (typeof teacher === 'number' ? teacher : teacher.id));

    let compareOldAndNewArrayLength = {
      'expected-learning-items': course.expected_learning_items.length === expectedLearningItems.length,
    };

    // df => dirty fields
    let df = getDirtyFields(dirtyFields, compareOldAndNewArrayLength);

    let isAddLang = false;
    if (df.language) isAddLang = true;
    if (course.language === null) isAddLang = true;

    let isAddLevelType = false;
    if (df['level-type']) isAddLevelType = true;
    if (course.level_type === null) isAddLevelType = true;

    //price_policy
    var price_policy = '';
    if (isFree) {
      price_policy = 'free';
    } else {
      if (hasMultiPrice) {
        price_policy = 'paid_with_two_price';
      } else {
        price_policy = 'paid_with_one_price';
      }
    }

    // Dirty Fields
    let data = {
      ...(isAddLang && { language_code: language }),
      ...(isAddLevelType && { level_type_id: levelType }),
      ...(df.title && { title }),
      ...(df['short-description'] && { short_description: shortDescription }),
      ...(df['full-description'] && { full_description: fullDescription }),
      ...(df.price && !hasMultiPrice && { price }),
      ...(df.start && { start }),
      ...(df.end && { end }),

      ...{
        price_policy: price_policy,
      },
      instructors,
      min_effort,
      weeks_to_complete,

      ...(!isFree &&
        hasMultiPrice && {
          price_with_certificate: price * 1,
        }),
      ...(!isFree &&
        hasMultiPrice && {
          price_without_certificate: price_with_licence * 1,
        }),
      ...{
        have_certificate: hasLicence && !isFree,
      },

      ...(df['expected-learning-items'] && {
        expected_learning_items_list: expectedLearningItems,
      }),
      prerequisites_list,
      ...(Boolean(publish) && { publish: true }),
    };

    if (!dirtyFields.length && !publish) {
      Toast(txtRT.form.noDiff, 'warn');
      return;
    }

    let roleName = paramCase(selectedRole.name);
    await dispatch(updateCourseItem(id, roleName, data));

    setBtnStatus(publish);
  };

  // life cycle methods
  useEffect(() => {
    if (id && permissions) {
      if (selectedRole.name === 'admin') {
        history.push('/');
      } else {
        let roleName = paramCase(selectedRole.name);
        dispatch(getCourseItem(id, roleName));
      }
    }

    // eslint-disable-next-line
  }, [permissions]);

  useEffect(() => {
    let condition = Boolean(course);
    if (condition) {
      let {
        expected_learning_items,
        end,
        full_description,
        language,
        image,
        level_type,
        price,
        price_without_certificate,
        short_description,
        title,
        start,
        video_url,
        prerequisites,
        price_policy,
        have_certificate,
        weeks_to_complete,
        min_effort,
        instructors,
      } = course;

      setIsFree(price_policy === 'free');
      setHasLicence(have_certificate);
      setHasMultiPrice(price_policy === 'paid_with_two_price');

      if (id)
        reset({
          end: end ? end : '',
          'expected-learning-items': expected_learning_items ? expected_learning_items.map(item => item.value) : [],
          prerequisites: prerequisites ? prerequisites?.map(item => item.value) : [],
          'full-description': full_description ? full_description : '',
          language: language ? language.code : 'fa',
          // image: image ? image : "",
          'level-type': level_type ? level_type.id : 3,
          price: price,
          'short-description': short_description ? short_description : '',
          title: title ? title : '',
          // "video-file": video_url ? video_url : "",
          start: start ? start : '',
          instructors: instructors,
          min_effort: min_effort ?? '',
          weeks_to_complete: weeks_to_complete ?? '',
          is_free: price_policy === 'free' ? '1' : '0',
          has_licence: have_certificate ? '1' : '0',
          price_with_licence: price_without_certificate,
        });
    }

    setSweet({ ...sweet, show: Boolean(btnStatus) ? true : false });

    // eslint-disable-next-line
  }, [course]);

  useEffect(() => {
    if (sweet.redirect) history.push('/');

    // eslint-disable-next-line
  }, [sweet.redirect]);

  useEffect(() => {
    dispatch(getAllLanguage());
    dispatch(getAllLevelTypes());
    dispatch(getOrganizationTeachers());
  }, []);

  useEffect(() => {
    if (course) {
      if (course.publish) {
        setSweet({ ...sweet, show: true });
      }

      if (course.publish === false) {
        Toast('اطلاعات شما به صورت موقت با موفقیت ثبت شد.', 'success');
      }
    }
  }, [course]);

  useEffect(() => {
    if (sweet.show) {
      dispatch(setCourseItemNull());
    }
  }, [sweet.show]);

  useEffect(() => {
    if (sweet.redirect) {
      history.push('/');
    }
  }, [sweet.redirect]);

  //Pre Requisites
  const refPreRequisiteAutoComplete = useRef();
  const { searchCourse: preRequisitesOptions, preRequisiteLoading: preRequisitesIsLoading } = useSelector(
    state => state.course
  );
  const [selectedRequisites, setSelectedRequisites] = useState([]);

  useEffect(() => {
    if (course != null) {
      setSelectedRequisites(course.prerequisites);
    }
  }, [course]);

  const [searchRequisite, setSearchRequisite] = useState('');

  const onRequisiteSelect = item => {
    if (item.length > 0) {
      if (!selectedRequisites.includes(item[0])) {
        setSelectedRequisites([...selectedRequisites, item[0]]);
      } else {
        Toast(form.label.errorExistItem, 'error');
      }
      refPreRequisiteAutoComplete.current.clear();
    }
  };

  const onRequisiteRemove = field => {
    // if (selectedRequisites.length > 1) {
    let newSelectedRequisites = selectedRequisites.filter(item => {
      return item.key !== field.key;
    });
    setSelectedRequisites(newSelectedRequisites);
  };

  const handleSearchRequisite = term => {
    setSearchRequisite(term);
  };

  function uploadFile(file, name) {
    if (!titleValue) {
      return setError('title', 'required', 'لطفا عنوان دوره را وارد کنید');
    }
    let uploadFileData = generateFileData(file, name, [{ title: titleValue }]);

    let roleName = paramCase(selectedRole.name);
    dispatch(updateCourseFileData(id, roleName, uploadFileData, name));
  }

  useEffect(() => {
    if (error) {
      Object.keys(error).forEach(item => {
        if (item !== 'non_field_errors') setError(item, 'manual', error[item][0]);
      });
    }
  }, [error]);

  function getDoneModalMessage() {
    if (selectedRole?.name === permissionTypes.admin || selectedRole?.name === permissionTypes.instructor) {
      return (
        ' ضمن عرض تشکر، درخواست شما با موفقیت ثبت شد، پس از تایید محتوی دوره از سمت نماینده سازمان، وضعیت درخواست شما فعال\n' +
        'خواهد شد.'
      );
    } else {
      return 'ساخت دوره با موفقیت انجام شد';
    }
  }

  function handleMultiPriceCheck(checked) {
    setHasMultiPrice(checked);
  }

  return (
    <Fragment>
      {course && !is_loading && (
        <div className="kt-portlet p-3 create-course">
          <Head title={txtRH.createCourse.title(id)} />
          <Form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
            <Tab.Container id="left-tabs-example" activeKey={ak}>
              <Row>
                <Col sm={3}>
                  <Nav variant="pills" className="flex-column">
                    {/* TAB LINK CONTENT => MARKETING */}
                    <Nav.Item className="my-1">
                      <Nav.Link
                        eventKey="marketing"
                        className={errorStyleForTabs.tab1}
                        onClick={() => {
                          if (ak !== 'marketing') onShowTabContent('marketing');
                        }}
                      >
                        <span className="h4">
                          <Badge variant="light" className="py-1 px-2 mx-2 ">
                            1
                          </Badge>
                        </span>
                        {tabLinks.marketing}
                      </Nav.Link>
                    </Nav.Item>
                    {/* TAB LINK CONTENT => INTRO */}
                    <Nav.Item className="my-1">
                      <Nav.Link
                        eventKey="intro"
                        className={errorStyleForTabs.tab2}
                        onClick={() => {
                          if (ak !== 'intro') onShowTabContent('intro');
                        }}
                      >
                        <span className="h4">
                          <Badge variant="light" className="py-1 px-2 mx-2">
                            2
                          </Badge>
                        </span>
                        {tabLinks.intro}
                      </Nav.Link>
                    </Nav.Item>
                    {/* TAB LINK CONTENT => PRICING POLICY */}
                    <Nav.Item className="my-1">
                      <Nav.Link
                        eventKey="pricing-policy"
                        className={errorStyleForTabs.tab3}
                        onClick={() => {
                          if (ak !== 'pricing-policy') onShowTabContent('pricing-policy');
                        }}
                      >
                        <span className="h4">
                          <Badge variant="light" className="py-1 px-2 mx-2 ">
                            3
                          </Badge>
                        </span>
                        {tabLinks.pricingPolicy}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <hr className="d-block my-5" />
                  <div className="my-2">
                    <Button variant="dark" block onClick={handleClickTempBtn}>
                      {btn.temp}
                    </Button>
                  </div>
                  <div className="my-2">
                    <Button variant="success" type="submit" block data-publish="true">
                      {btn.stable}
                    </Button>
                  </div>
                </Col>

                <Col sm={9}>
                  <Tab.Content className="p-3">
                    {/* TAB CONTENT => MARKETING */}
                    <Tab.Pane eventKey="marketing">
                      <p className="lead p-2">این اطلاعات به دانشجو کمک میکنه ببینه آیا دوره شما براش مناسب یا نه</p>

                      {/* ======= EXPECTED-LEARNING-ITEMS FF ======= */}
                      <Form.Group controlId="expected-learning-items">
                        <Form.Label>{form.label.whatLearns}</Form.Label>
                        <Form.Label className={'mb-2'}>
                          در این قسمت با اضافه کردن کلید واژه هایی می توانید تگ هایی برای دوره تان ایجاد کنید که در سرچ
                          دوره ها با نوشتن این تگ ها دوره شما نمایش داده می شود(به عنوان مثال: python)
                        </Form.Label>
                        <FieldArray
                          {...{
                            control,
                            register,
                            getValues,
                            clearError,
                            name: 'expected-learning-items',
                            initValue: '',
                            ...(course && {
                              test: course['expected-learning-items'],
                            }),
                            reset,
                          }}
                        />
                        {errors['expected-learning-items'] && (
                          <div>
                            <span className="text-danger">{errors['expected-learning-items'].message}</span>
                          </div>
                        )}
                      </Form.Group>

                      {/* ======= PREREQUISITES FF ======= */}
                      <Form.Group controlId="prerequisites">
                        <Form.Label>{form.label.selectPreRequisites}</Form.Label>

                        <AsyncTypeahead
                          className="pre-requisites"
                          defaultInputValue={''}
                          id="user"
                          ref={refPreRequisiteAutoComplete}
                          isLoading={preRequisitesIsLoading}
                          minLength={1}
                          ignoreDiacritics={false}
                          labelKey={option => `${option.title} (${option.short_description})`}
                          onSearch={term => {
                            handleSearchRequisite(term);
                          }}
                          options={preRequisitesOptions}
                          onChange={onRequisiteSelect}
                          placeholder="جستجو عنوان دوره..."
                          emptyLabel="موردی یافت نشد"
                          searchText="در حال جستجو"
                          renderMenuItemChildren={(option, props) => (
                            <div className="pre-requisites-items">
                              <span>{option.title + '  ( ' + option.key + ' )  '}</span>
                            </div>
                          )}
                        />

                        {selectedRequisites.map(field => {
                          return (
                            <Form.Row key={field.key} className="m-2 pre-requisites-selected">
                              <Col>
                                <Form.Control
                                  defaultValue={field.key}
                                  // name={index}
                                  type="text"
                                  // ref={register()}
                                />
                              </Col>
                              <Col>
                                <Button variant="danger" onClick={() => onRequisiteRemove(field)}>
                                  <i className="fas fa-times p-0" />
                                </Button>
                              </Col>
                            </Form.Row>
                          );
                        })}
                      </Form.Group>

                      {/* ======= LEVEL-TYPE FF ======= */}
                      <Form.Group controlId="level-type">
                        <Form.Label>{form.label.stateCourse}</Form.Label>
                        <Form.Control
                          name="level-type"
                          as="select"
                          ref={register({ required: 'این فیلد الزامی است' })}
                          className={`${errors['level-type'] && 'border border-danger'}`}
                        >
                          {allLevelTypes.data?.map(item => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            );
                          })}
                        </Form.Control>
                        {errors['level-type'] && <span className="text-danger">{errors['level-type'].message}</span>}
                      </Form.Group>

                      {/* ======= LANGUAGE FF ======= */}
                      <Form.Group controlId="language">
                        <Form.Label>{form.label.language}</Form.Label>
                        <Form.Control
                          name="language"
                          as="select"
                          ref={register({ required: 'این فیلد الزامی است' })}
                          className={`${errors['language'] && 'border border-danger'}`}
                        >
                          {allLanguages.data?.map(item => {
                            return (
                              <option key={item.code} value={item.code}>
                                {item.name}
                              </option>
                            );
                          })}
                        </Form.Control>
                        {errors['language'] && <span className="text-danger">{errors['language'].message}</span>}
                      </Form.Group>

                      {/* ======= NEXT AND PREV ======= */}
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                        }}
                      >
                        <Button onClick={() => onShowTabContent('intro')}>
                          مرحله بعد <i className="fas fa-arrow-left p-0 pl-1" />
                        </Button>
                      </div>
                    </Tab.Pane>
                    {/* TAB CONTENT => INTRO */}
                    <Tab.Pane eventKey="intro">
                      {/* ======= TITLE FF ======= */}
                      <Form.Group>
                        <Form.Label>
                          {form.label.title}({!titleValue ? 60 : titleValue.length > 60 ? 0 : 60 - titleValue.length})
                        </Form.Label>
                        <Form.Control
                          name="title"
                          type="text"
                          maxLength="60"
                          ref={register({
                            required: 'این فیلد الزامی است',
                            minLength: 10,
                          })}
                          placeholder={' به عنوان مثال: آموزش پیشرفته پایتون'}
                          className={`${errors.title && 'border border-danger'}`}
                        />
                        {errors.title && errors.title.type === 'required' && (
                          <span className="text-danger">{errors.title.message}</span>
                        )}
                        {errors.title && errors.title.type === 'minLength' && (
                          <span className="text-danger">{txtRHF.error.minLength(10)}</span>
                        )}
                      </Form.Group>

                      {/* ======= SHORT DESCRIPTION FF ======= */}
                      <Form.Group>
                        <Form.Label>
                          {form.label.smallDesc}(
                          {!shortDescValue ? 160 : shortDescValue.length > 160 ? 0 : 160 - shortDescValue.length})
                        </Form.Label>
                        <Form.Control
                          name="short-description"
                          as="textarea"
                          rows="2"
                          maxLength="160"
                          ref={register({
                            required: 'این فیلد الزامی است',
                            minLength: 20,
                          })}
                          className={`${errors['short-description'] && 'border border-danger'}`}
                          placeholder={'به عنوان مثال: در این دوره شما برنامه نویسی را به روش...'}
                        />
                        {errors['short-description'] && errors['short-description'].type === 'required' && (
                          <span className="text-danger">{errors['short-description'].message}</span>
                        )}
                        {errors['short-description'] && errors['short-description'].type === 'minLength' && (
                          <span className="text-danger">{txtRHF.error.minLength(20)}</span>
                        )}
                      </Form.Group>

                      {/* ======= FULL DESCRIPTION FF ======= */}
                      <Form.Group>
                        <Form.Label>{form.label.longDesc}</Form.Label>
                        <Form.Control
                          name="full-description"
                          as="textarea"
                          rows="4"
                          ref={register({ required: 'این فیلد الزامی است' })}
                          className={`${errors['full-description'] && 'border border-danger'}`}
                          placeholder={'به عنوان مثال: در این دوره تعداد زیادی مساله کاربردی را حل خواهید کرد...'}
                        />
                        {errors['full-description'] && errors['full-description'].type === 'required' && (
                          <span className="text-danger">{errors['full-description'].message}</span>
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label> استاد</Form.Label>
                        <Select
                          control={control}
                          rules={{
                            validate: {
                              required: value => {
                                if (!value.length) return 'این فیلد الزامی است';
                              },
                            },
                          }}
                          isClearable
                          error={errors?.instructors?.message}
                          name={'instructors'}
                          isMulti
                          options={instructors}
                          getOptionValue={item => (typeof item === 'number' ? item : item.user.id)}
                          getOptionLabel={item => {
                            if (typeof item === 'number') {
                              let staff = instructors?.find(t => t.id === item);

                              if (staff) {
                                return `${staff.user.first_name} ${staff.user.last_name}`;
                              }
                              return '';
                            }
                            return `${item.user.first_name} ${item.user.last_name}`;
                          }}
                        />
                        <Form.Text>
                          اگر نام استاد سازمان شما در لیست نمی‌باشد،{' '}
                          <Link to={'/instructor/new'}>
                            {' '}
                            <span title={'ارسال درخواست'} style={{ fontSize: '1rem', marginInline: '.2rem' }}>
                              درخواست استادی{' '}
                            </span>
                          </Link>{' '}
                          ارسال نمایید
                        </Form.Text>
                      </Form.Group>

                      {/* ======= START AND END DATE TIME ======= */}
                      <Form.Label style={{ fontSize: '1.2rem', marginBottom: '.5rem' }}>
                        برنامه زمان‌بندی و اطلاعات
                      </Form.Label>
                      <Row style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        {/* ======= START DATE TIME FF ======= */}
                        <Col xs={12} sm={6} xl={3}>
                          <DateTimePicker
                            label={'تاریخ شروع دوره'}
                            placeholder={'شروع دوره'}
                            name={'start'}
                            control={control}
                            rules={{ required: 'این فیلد الزامی  است' }}
                            error={errors['start']}
                            classes={{ timeClass: 'time-class' }}
                            initValue={getValues('start')}
                          />
                        </Col>
                        {/* ======= END DATE TIME FF ======= */}
                        {startDate && (
                          <Col xs={12} sm={6} xl={3}>
                            <DateTimePicker
                              label={'تاریخ پایان دوره'}
                              placeholder={'پایان دوره'}
                              name={'end'}
                              control={control}
                              rules={{ required: 'این فیلد الزامی  است' }}
                              error={errors['end']}
                              minDate={startDate}
                              classes={{ timeClass: 'time-class' }}
                              initValue={getValues('end')}
                            />
                          </Col>
                        )}
                        {/* COURSE LENGTH */}
                        <Col xs={12} sm={6} xl={3}>
                          <Form.Label>حداقل ساعات مورد نیاز در هفته</Form.Label>
                          <Form.Control
                            name="min_effort"
                            control={control}
                            type="number"
                            ref={register({
                              required: 'این فیلد الزامی است',
                            })}
                            className={errors?.min_effort?.message ? 'border border-danger mb-4' : 'mb-4'}
                            min={1}
                          />
                          {errors['min_effort'] && errors['min_effort'].type === 'required' && (
                            <span className="text-danger">{errors['min_effort'].message}</span>
                          )}
                        </Col>
                        <Col xs={12} sm={6} xl={3}>
                          <Form.Label>تعداد هفته مورد نیاز</Form.Label>
                          <Form.Control
                            control={control}
                            ref={register({
                              required: 'این فیلد الزامی است',
                            })}
                            type="number"
                            error={errors?.weeks_to_complete?.message}
                            className={errors?.min_effort?.message ? 'border border-danger mb-4' : 'mb-4'}
                            name="weeks_to_complete"
                            min={1}
                          />
                          {errors['weeks_to_complete'] && errors['weeks_to_complete'].type === 'required' && (
                            <span className="text-danger">{errors['weeks_to_complete'].message}</span>
                          )}
                        </Col>
                      </Row>

                      {/* ======= NEXT AND PREV ======= */}
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Button onClick={() => onShowTabContent('marketing')}>
                          <i className="fas fa-arrow-right" /> مرحله قبل
                        </Button>
                        <Button onClick={() => onShowTabContent('pricing-policy')}>
                          مرحله بعد <i className="fas fa-arrow-left p-0 pl-1" />
                        </Button>
                      </div>
                    </Tab.Pane>
                    {/* TAB CONTENT => PRICING POLICY */}
                    <Tab.Pane eventKey="pricing-policy">
                      {/* ======= PRICE FF ======= */}
                      <Form.Group controlId="free">
                        <Form.Label>رایگان - غیر رایگان </Form.Label>
                        <Form.Control
                          name="is_free"
                          as="select"
                          ref={register({})}
                          onChange={e => {
                            setIsFree(e.target.value === '1');
                          }}
                          className={'border'}
                        >
                          {[
                            { id: 1, name: 'رایگان' },
                            { id: 0, name: 'غیر رایگان' },
                          ].map(item => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            );
                          })}
                        </Form.Control>
                      </Form.Group>

                      {!isFree && (
                        <Form.Group controlId="has_licence">
                          <Form.Label>آیا دوره با مدرک است؟ </Form.Label>
                          <Form.Control
                            name="has_licence"
                            as="select"
                            ref={register({})}
                            onChange={e => {
                              setHasLicence(e.target.value === '1');
                            }}
                            className={'border'}
                          >
                            {[
                              { id: 0, name: 'مدرک ندارد' },
                              { id: 1, name: 'مدرک دارد' },
                            ].map(item => {
                              return (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </Form.Control>
                        </Form.Group>
                      )}

                      {!isFree && (
                        <Form.Group>
                          <Form.Label>قیمت دوره</Form.Label>
                          <Form.Control
                            name="price"
                            placeholder={'به عنوان مثال: 20000'}
                            type="text"
                            ref={register({
                              required: 'این فیلد الزامی  است',
                              pattern: {
                                value: /^[0-9][0-9]*$/,
                                message: 'کیبورد خود را به انگلیسی تغییر دهید و از مقدار معتبر استفاده کنید.',
                              },
                            })}
                            maxLength={8}
                            onChange={e => {
                              let regex = /^[0-9][0-9]*$/;
                              let hasPattern = regex.test(e.target.value);
                              if (!hasPattern) {
                                setError(
                                  'price',
                                  'notMatch',
                                  'کیبورد خود را به انگلیسی تغییر دهید و از مقدار معتبر استفاده کنید.'
                                );
                              } else {
                                clearError('price');
                              }

                              if (e.target.value < 1000) {
                                setError('price', 'notMatch', 'قیمت حداقل باید ۱۰۰۰ تومان باشد');
                              }
                            }}
                            className={`${errors['price'] && 'border border-danger'}`}
                          />
                          {errors['price'] && <span className="text-danger">{errors['price'].message}</span>}
                          {!Boolean(errors.price) && getValues('price') && (
                            <div>
                              <span>{NumberToWords.convert(parseInt(getValues('price')))} تومان</span>
                            </div>
                          )}
                        </Form.Group>
                      )}

                      {!isFree && hasLicence && (
                        <>
                          <Form.Group>
                            <Form.Check
                              name="has_multi_price"
                              id={'has_multi_price.1'}
                              type="checkbox"
                              custom
                              checked={hasMultiPrice}
                              label={'امکان ارائه دوره بدون مدرک وجود دارد'}
                              onChange={e => handleMultiPriceCheck(e.target.checked)}
                            />
                          </Form.Group>
                        </>
                      )}

                      {!isFree && hasLicence && hasMultiPrice && (
                        <Form.Group>
                          <Form.Label>قیمت دوره درصورت ارائه بدون مدرک باید از قیمت اصلی کمتر باشد</Form.Label>
                          <Form.Control
                            name="price_with_licence"
                            placeholder={'به عنوان مثال: 20000'}
                            type="text"
                            ref={register({
                              required: 'این فیلد الزامی  است',
                              pattern: {
                                value: /^[0-9][0-9]*$/,
                                message: 'کیبورد خود را به انگلیسی تغییر دهید و از مقدار معتبر استفاده کنید.',
                              },
                            })}
                            maxLength={8}
                            onChange={e => {
                              let regex = /^[0-9][0-9]*$/;
                              let hasPattern = regex.test(e.target.value);
                              if (!hasPattern) {
                                setError(
                                  'price_with_licence',
                                  'notMatch',
                                  'کیبورد خود را به انگلیسی تغییر دهید و از مقدار معتبر استفاده کنید.'
                                );
                              } else {
                                clearError('price_with_licence');
                              }

                              let a = getValues('price_with_licence') * 1;
                              let b = getValues('price') * 1;

                              if (a < 1000 || b < 1000) {
                                setError('price_with_licence', 'notMatch', 'قیمت حداقل باید ۱۰۰۰ تومان باشد');
                              }

                              if (a > b) {
                                setError('price_with_licence', 'notMatch', 'قیمت بدون مدرک باید کمتر از با مدرک باشد');
                              }
                            }}
                            className={`${errors['price_with_licence'] && 'border border-danger'}`}
                          />
                          {errors['price_with_licence'] && (
                            <span className="text-danger">{errors['price_with_licence'].message}</span>
                          )}
                          {!Boolean(errors.price_with_licence) && getValues('price_with_licence') && (
                            <div>
                              <span>{NumberToWords.convert(parseInt(getValues('price_with_licence')))} تومان</span>
                            </div>
                          )}
                        </Form.Group>
                      )}

                      {/* ======= IMAGE FF ======= */}
                      <Form.Group>
                        <Form.Label>{form.label.file('عکس', 3)}</Form.Label>
                        <Controller
                          type="file"
                          defaultValue={id && course?.data?.logo}
                          data-type="image"
                          as={FileInput}
                          onChange={([event]) => {
                            return event;
                          }}
                          uploadFile={uploadFile}
                          name="image"
                          data-name="image"
                          control={control}
                          setError={setError}
                          clearError={clearError}
                          errors={errors}
                          limitSize={3}
                          accept="image/*"
                          classNames={{
                            container: 'custom-file',
                            input: 'custom-file-input',
                            label: `${errors.image ? 'border border-danger' : ''} custom-file-label`,
                          }}
                          label="آپلود تصویر"
                          rules={{
                            ...(!Boolean(course.image) && {
                              required: 'این فیلد الزامی است',
                            }),
                          }}
                        />
                      </Form.Group>
                      {!dirtyFields.includes('image') && showImagePreview && course.image !== null && (
                        <Row>
                          <Col>
                            <div className={'d-flex justify-content-center mb-5'}>
                              <div>
                                <img className={'w-100 d-block'} src={course.image} />
                                <div className={'text-dark text-center'}>تصویر آپلود شده</div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      )}
                      {/* ======= VIDEO FF ======= */}
                      <Row>
                        <Col xs={12} sm={6} md={10}>
                          <Form.Group>
                            <Form.Label>{form.label.file('ویدیو', 30)}</Form.Label>
                            <Controller
                              type="file"
                              data-type="video"
                              as={FileInput}
                              onChange={([event]) => {
                                return event;
                              }}
                              name="video-file"
                              data-name="video-file"
                              control={control}
                              setError={setError}
                              clearError={clearError}
                              errors={errors}
                              limitSize={30}
                              accept="video/*"
                              classNames={{
                                container: 'custom-file',
                                input: 'custom-file-input',
                                label: `${errors['video-url'] ? 'border border-danger' : ''} custom-file-label`,
                              }}
                              label={`آپلود ویدیو`}
                            />
                            {!showVideoPreview && <span className={'text-success'}>ویدیو با موفقیت بارگزاری شد.</span>}
                          </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} md={2} style={{ marginTop: '25px' }}>
                          <Button
                            onClick={() => uploadFile(videoFile, 'video_file')}
                            disabled={isLoadingVideoFile || !Boolean(videoFile)}
                            block
                          >
                            {isLoadingVideoFile ? <Spinner animation={'border'} variant={'light'} /> : 'آپلود ویدیو'}
                          </Button>
                        </Col>
                      </Row>

                      {!dirtyFields.includes('video-file') &&
                        course?.original_video_url !== 'None' &&
                        showVideoPreview && (
                          <Row>
                            <Col>
                              <div className={'d-flex justify-content-center mb-5'}>
                                <div>
                                  <video width="400" controls>
                                    <source src={course.original_video_url} type="video/mp4" />
                                  </video>
                                  <div className={'text-dark text-center'}>ویدیو آپلود شده</div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        )}
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                        }}
                      >
                        <Button onClick={() => onShowTabContent('intro')}>
                          <i className="fas fa-arrow-right" /> مرحله قبل
                        </Button>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Form>
        </div>
      )}
      <Loader visible={is_loading} />
      <SweetAlert
        type="success"
        // title={txtSA.title(id, "دوره")}
        show={sweet.show}
        onConfirm={() => setSweet({ show: false, redirect: true })}
        confirmBtnText={txtSA.btn}
        onCancel={() => setSweet({ show: false, redirect: true })}
        confirmBtnBsStyle="success"
      >
        {getDoneModalMessage()}
      </SweetAlert>
    </Fragment>
  );
};

const formStyle = { position: 'relative' };

/**
 *
 * @param {Array} df
 * @param {object} conal Compare Old and New Array Length
 * @returns
 */

function getDirtyFields(df, conal) {
  // expected learning Items
  let flagDirtyELI = false;
  df.forEach(item => {
    if (item.includes('expected-learning-items')) {
      flagDirtyELI = true;
    }
  });
  // check remove array fields
  if (!conal['expected-learning-items']) flagDirtyELI = true;

  // prerequisites
  let flagDirtyP = false;
  df.forEach(item => {
    if (item.includes('prerequisites')) {
      flagDirtyP = true;
    }
  });

  // if (!conal["expected-learning-items"]) {
  //   flagDirtyP = true;
  // }

  return {
    'expected-learning-items': flagDirtyELI,
    prerequisites: flagDirtyP,
    language: df.includes('language'),
    'level-type': df.includes('level-type'),
    title: df.includes('title'),
    'short-description': df.includes('short-description'),
    'full-description': df.includes('full-description'),
    licence: df.includes('licence'),
    price: df.includes('price'),
    start: df.includes('start'),
    end: df.includes('end'),
    price_policy: df.includes('price_policy'),
    price_with_licence: df.includes('price_with_licence'),
    is_free: df.includes('is_free'),
    // image: df.includes("image"),
    // "video-file": df.includes("video-file"),
  };
}

function generateFileData(data, name, otherData) {
  let uploadData = new FormData();

  // get type of file
  let type = data.type.split('/').slice(-1)[0];
  let newName = `${name}.${type}`;
  uploadData.append(name, data, newName);
  otherData.map(function(data) {
    for (let key in data) {
      uploadData.append(key, data[key]);
    }
  });

  return uploadData;
}

function generateFormData(data, arrayData) {
  let newData = { ...data };
  // let newFileData = { ...fileData };
  let newArrayData = { ...arrayData };

  let uploadData = new FormData();
  Object.keys(newData).forEach(item => {
    uploadData.append(item, newData[item]);
  });

  Object.keys(newArrayData).forEach(item => {
    newArrayData[item].forEach(i => {
      uploadData.append(item, i);
    });
  });

  return uploadData;
}

export default UpdateCourse;
